import styled from 'styled-components';

export const ItemContainer = styled.div`
    margin: ${({ margin }) => margin};
`;

export const ItemHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    cursor: pointer;
`;

export const ItemHeaderTextContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ItemHeaderText = styled.h3`
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 4px 0 12px 6px;
`;

export const ItemContent = styled.div`
    overflow: hidden;
    max-height: ${({ isCollapsed, maxHeight }) => (isCollapsed ? 0 : maxHeight)}px;
    transition: max-height ease-out ${({ animationDelay }) => animationDelay}s;
`;
